"use client";
import { jsx as r, Fragment as t } from "react/jsx-runtime";
import { createSvgIcon as e } from "@mui/material/utils";
const i = e(
  /* @__PURE__ */ r(t, { children: /* @__PURE__ */ r(
    "path",
    {
      d: "M21 12.71H2.99998C2.60998 12.71 2.28998 12.39 2.28998 12C2.28998 11.61 2.60998 11.29 2.99998 11.29H21C21.39 11.29 21.71 11.61 21.71 12C21.71 12.39 21.39 12.71 21 12.71Z",
      fill: "currentColor"
    }
  ) }),
  "KmxMinusStroked"
);
export {
  i as default
};
